export default {
    namespaced: true,
    state: {
        isActiveContast: false,
        overlay: false,
        dialog: { show: false, text: null, title: null }
    },
    mutations: {
        switchActiveContrast (state) {
            state.isActiveContast = !state.isActiveContast;
        },
        showOverlay (state) {
            state.overlay = true;
        },
        hideOverlay (state) {
            state.overlay = false;
        },
        showInfoDialog (state, payload) {
            state.dialog.title = "Informacje";
            state.dialog.text = payload;
            state.dialog.show = true;
        },
        showErrorDialog (state, payload) {
            state.dialog.title = "Błąd";
            state.dialog.text = payload;
            state.dialog.show = true;
        },
        hideDialog (state) {
            state.dialog.show = false;
            state.dialog.title = null;
            state.dialog.text = null;
        }
    },
    getters: {
        getOverlay (state) {
            return state.overlay;
        },
        getDialog (state) {
            return state.dialog;
        }
    }
}